export default {
      id: "refresh-usage",
      viewBox: "0 0 22 22",
      url: "/dist/svg/" + "sprite.svg#refresh-usage",
      toString: function () {
        return this.url;
      }
    }